export default __webpack_public_path__ + "static/media/1864.f6856947.png";